import React, { useLayoutEffect } from 'react';
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";

am4core.useTheme(am4themes_animated);

const BankConsiderationChart = ({ mainData }) => {
  useLayoutEffect(() => {
    if (!mainData || !mainData.chart_data) {
      return; 
    }

    let chart = am4core.create("bank-consideration-chart", am4charts.XYChart);
 
    chart.logo.disabled = true;

    const transformedData = mainData.chart_data.map(item => ({
      year: item.Year,
      Absa: item.Absa,
      Capitec: item.Capitec,
      FNB: item.FNB,
      Nedbank: item.Nedbank,
      "Standard Bank": item["Standard Bank"],
      TymeBank: item.TymeBank,
      "Standard Bank Rank": item["Standard Bank Rank"] 
    }));
    
    chart.data = transformedData;

    let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
    categoryAxis.dataFields.category = "year";
    categoryAxis.renderer.grid.template.disabled = true;
    categoryAxis.renderer.line.disabled = true;
    categoryAxis.renderer.minGridDistance = 30;
    categoryAxis.numberFormatter.numberFormat = "#";


    let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
    valueAxis.renderer.grid.template.disabled = true;
    valueAxis.renderer.labels.template.disabled = true;

    const bankNames = ["Absa", "Capitec", "FNB", "Nedbank", "Standard Bank", "TymeBank"];
    const colors = [am4core.color('#DF1641'), am4core.color('#FF3393'), am4core.color('#00CAFF'), am4core.color('#006E2C'), am4core.color('#0033A1'), am4core.color('#FFC000')];

    // Create a series for each bank
    bankNames.forEach((bank, index) => {
      let series = chart.series.push(new am4charts.LineSeries());
      series.dataFields.valueY = bank;
      series.dataFields.categoryX = "year";
      series.name = bank;
      series.strokeWidth = 1.7;
      series.tensionX = 0.8;
      series.stroke = colors[index];
      series.tooltipText = "{name}: [bold]{valueY}[/]";

      series.tooltip.getFillFromObject = false; 
      series.tooltip.background.fill = colors[index]; 
      series.tooltip.label.fill = am4core.color('#FFFFFF'); 
   
      let boxBullet = series.bullets.push(new am4charts.Bullet());
      let roundedRectangle = boxBullet.createChild(am4core.RoundedRectangle);
      roundedRectangle.width = 35;
      roundedRectangle.height = 35;
      roundedRectangle.fill = colors[index];
      roundedRectangle.stroke = series.stroke;
      roundedRectangle.strokeWidth = 1;
      roundedRectangle.horizontalCenter = 'middle';
      roundedRectangle.verticalCenter = 'middle';
      roundedRectangle.cornerRadius(4, 5, 5, 4);

      let labelBullet = series.bullets.push(new am4charts.LabelBullet());
      labelBullet.label.text = "{valueY}";
      labelBullet.label.fill = am4core.color("#FFF");
      labelBullet.label.fontSize = 17;
      labelBullet.label.fontWeight = "500";
      labelBullet.label.horizontalCenter = "middle";
      labelBullet.label.verticalCenter = "middle";

      labelBullet.label.adapter.add("y", (y, target) => {
        return -roundedRectangle.height / 2 + 17;
      });
    });

    // Add ranking label for Standard Bank
           chart.events.on("datavalidated", function() {    //An event listener allowing to execute a function when a specific event occurs on the chart
             let sb_direction = chart.data[9];  
             chart.data.forEach((item, index) => {
               if (index === chart.data.length - 1){
                 return
               }
               let label = chart.plotContainer.createChild(am4core.Label);
               label.text = `${item['Standard Bank Rank']}`; 
               label.fontSize = 20;
               label.fontWeight = 'bold';
               label.fill = am4core.color('#0473EA'); // 
               label.align = 'center';
               label.isMeasured = false;
               label.x = categoryAxis.categoryToPoint(item['Year']).x - label.measuredWidth / 2;
               label.y = -20; 
       
               if (index === chart.data.length - 2){
                 if (sb_direction['sb_up'] == 'Down'){
                   label.background.fill = am4core.color('#FF0000'); // Red
                 }   
                 else if (sb_direction['sb_up'] == 'Up'){
                   label.background.fill = am4core.color('#00ff00'); // Green          
                 }          
                 else {
                   label.background.fill = am4core.color('#ffffff'); // White
                 }          
               }   
             });
           });
    chart.legend = new am4charts.Legend();
    chart.legend.position = "bottom";
    chart.legend.itemContainers.template.paddingTop = 30;
    chart.legend.labels.template.paddingRight = 60;
    chart.legend.itemContainers.template.marginTop = 20;
    chart.legend.itemContainers.template.width = 100;
    chart.legend.markers.template.width = 20;
    chart.legend.markers.template.height = 20;
    chart.legend.labels.template.paddingRight = 30;
    chart.legend.labels.template.paddingLeft = 8;
    chart.legend.labels.template.fontSize = 12;

    chart.cursor = new am4charts.XYCursor();

    return () => {
      chart.dispose();
    };
  }, [mainData]);

  return <div id="bank-consideration-chart" style={{ width: "100%", height: "600px" }}></div>;
};

export default BankConsiderationChart;
